import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a507525c from 'nuxt_plugin_plugin_a507525c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_storeserver_81cd0cba from 'nuxt_plugin_storeserver_81cd0cba' // Source: ../../../plugins/store-server (mode: 'all')
import nuxt_plugin_sentrytracker_b84c0384 from 'nuxt_plugin_sentrytracker_b84c0384' // Source: ../../../plugins/sentry-tracker (mode: 'all')
import nuxt_plugin_hmt_129cfb7e from 'nuxt_plugin_hmt_129cfb7e' // Source: ../../../plugins/hmt.client (mode: 'client')
import nuxt_plugin_thirdpartystat_1effc0e4 from 'nuxt_plugin_thirdpartystat_1effc0e4' // Source: ../../../plugins/third-party-stat.client (mode: 'client')
import nuxt_plugin_qiyukf_15b74cd4 from 'nuxt_plugin_qiyukf_15b74cd4' // Source: ../../../plugins/qiyukf.client (mode: 'client')
import nuxt_plugin_vant_925e8cb6 from 'nuxt_plugin_vant_925e8cb6' // Source: ../../../plugins/vant (mode: 'all')
import nuxt_plugin_wenjuanui_54d8b146 from 'nuxt_plugin_wenjuanui_54d8b146' // Source: ../../../plugins/wenjuan-ui (mode: 'all')
import nuxt_plugin_wenjuanui2_463d7716 from 'nuxt_plugin_wenjuanui2_463d7716' // Source: ../../../plugins/wenjuan-ui2 (mode: 'all')
import nuxt_plugin_wenjuanbusinessprepare_3613f503 from 'nuxt_plugin_wenjuanbusinessprepare_3613f503' // Source: ../../../plugins/wenjuan-business-prepare (mode: 'all')
import nuxt_plugin_wenjuanbusiness_12eaddc9 from 'nuxt_plugin_wenjuanbusiness_12eaddc9' // Source: ../../../plugins/wenjuan-business (mode: 'all')
import nuxt_plugin_wenjuanbusiness_545f50e0 from 'nuxt_plugin_wenjuanbusiness_545f50e0' // Source: ../../../plugins/wenjuan-business.client (mode: 'client')
import nuxt_plugin_common_25e198df from 'nuxt_plugin_common_25e198df' // Source: ../../../plugins/common (mode: 'all')
import nuxt_plugin_clientwidth_f3ca1d7e from 'nuxt_plugin_clientwidth_f3ca1d7e' // Source: ../../../plugins/client-width.client (mode: 'client')
import nuxt_plugin_vconsole_490171c4 from 'nuxt_plugin_vconsole_490171c4' // Source: ../../../plugins/vconsole.client (mode: 'client')
import nuxt_plugin_infiniteScroll_3b65f2e4 from 'nuxt_plugin_infiniteScroll_3b65f2e4' // Source: ../../../plugins/infiniteScroll.client (mode: 'client')
import nuxt_plugin_richcontentquill_63de7485 from 'nuxt_plugin_richcontentquill_63de7485' // Source: ../../../plugins/rich-content-quill.client (mode: 'client')
import nuxt_plugin_richeditor_41ed85a2 from 'nuxt_plugin_richeditor_41ed85a2' // Source: ../../../plugins/rich-editor.client (mode: 'client')
import nuxt_plugin_envapplicationuser_6756a2fd from 'nuxt_plugin_envapplicationuser_6756a2fd' // Source: ../../../plugins/env-application-user.client (mode: 'client')
import nuxt_plugin_pwainstallprompt_7649f11c from 'nuxt_plugin_pwainstallprompt_7649f11c' // Source: ../../../plugins/pwa-install-prompt.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"问卷网-免费问卷调查平台","htmlAttrs":{"lang":"zh-CN","repo":"main","timing":"04-19 \n  10:37","author":"kyol"},"meta":[{"charset":"UTF-8"},{"name":"renderer","content":"webkit"},{"name":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"google","content":"notranslate"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"viewport","content":"width=device-width, viewport-fit=cover"},{"hid":"applicable-device","name":"applicable-device","content":"pc,mobile"},{"hid":"keywords","name":"keywords","content":"问卷调查,调查问卷,满意度调查,市场调查,报名登记表,问卷网"},{"hid":"description","name":"description","content":"免费问卷调查平台-问卷网，拥有创新的编辑界面和结果分析界面，海量的问卷和表单模板，提供20余万精品模板；支持微信，微博，QQ等多种发布模式。专注于为企业和个人提供问卷表单的创建，发布，管理，收集及分析服务。"},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a507525c === 'function') {
    await nuxt_plugin_plugin_a507525c(app.context, inject)
  }

  if (typeof nuxt_plugin_storeserver_81cd0cba === 'function') {
    await nuxt_plugin_storeserver_81cd0cba(app.context, inject)
  }

  if (typeof nuxt_plugin_sentrytracker_b84c0384 === 'function') {
    await nuxt_plugin_sentrytracker_b84c0384(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hmt_129cfb7e === 'function') {
    await nuxt_plugin_hmt_129cfb7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_thirdpartystat_1effc0e4 === 'function') {
    await nuxt_plugin_thirdpartystat_1effc0e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_qiyukf_15b74cd4 === 'function') {
    await nuxt_plugin_qiyukf_15b74cd4(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_925e8cb6 === 'function') {
    await nuxt_plugin_vant_925e8cb6(app.context, inject)
  }

  if (typeof nuxt_plugin_wenjuanui_54d8b146 === 'function') {
    await nuxt_plugin_wenjuanui_54d8b146(app.context, inject)
  }

  if (typeof nuxt_plugin_wenjuanui2_463d7716 === 'function') {
    await nuxt_plugin_wenjuanui2_463d7716(app.context, inject)
  }

  if (typeof nuxt_plugin_wenjuanbusinessprepare_3613f503 === 'function') {
    await nuxt_plugin_wenjuanbusinessprepare_3613f503(app.context, inject)
  }

  if (typeof nuxt_plugin_wenjuanbusiness_12eaddc9 === 'function') {
    await nuxt_plugin_wenjuanbusiness_12eaddc9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wenjuanbusiness_545f50e0 === 'function') {
    await nuxt_plugin_wenjuanbusiness_545f50e0(app.context, inject)
  }

  if (typeof nuxt_plugin_common_25e198df === 'function') {
    await nuxt_plugin_common_25e198df(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientwidth_f3ca1d7e === 'function') {
    await nuxt_plugin_clientwidth_f3ca1d7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_490171c4 === 'function') {
    await nuxt_plugin_vconsole_490171c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteScroll_3b65f2e4 === 'function') {
    await nuxt_plugin_infiniteScroll_3b65f2e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_richcontentquill_63de7485 === 'function') {
    await nuxt_plugin_richcontentquill_63de7485(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_richeditor_41ed85a2 === 'function') {
    await nuxt_plugin_richeditor_41ed85a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_envapplicationuser_6756a2fd === 'function') {
    await nuxt_plugin_envapplicationuser_6756a2fd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwainstallprompt_7649f11c === 'function') {
    await nuxt_plugin_pwainstallprompt_7649f11c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
